import React from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { sharedPluginStateHookMigratorFactory, useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import ToolbarBlockType from './ToolbarBlockType';
var usePrimaryToolbarComponentPluginState = sharedPluginStateHookMigratorFactory(function (api) {
  var currentBlockType = useSharedPluginStateSelector(api, 'blockType.currentBlockType');
  var blockTypesDisabled = useSharedPluginStateSelector(api, 'blockType.blockTypesDisabled');
  var availableBlockTypes = useSharedPluginStateSelector(api, 'blockType.availableBlockTypes');
  var availableBlockTypesInDropdown = useSharedPluginStateSelector(api, 'blockType.availableBlockTypesInDropdown');
  var formattingIsPresent = useSharedPluginStateSelector(api, 'blockType.formattingIsPresent');
  return {
    currentBlockType: currentBlockType,
    blockTypesDisabled: blockTypesDisabled,
    availableBlockTypes: availableBlockTypes,
    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
    formattingIsPresent: formattingIsPresent
  };
}, function (api) {
  var _useSharedPluginState = useSharedPluginState(api, ['blockType']),
    blockTypeState = _useSharedPluginState.blockTypeState;
  return {
    currentBlockType: blockTypeState === null || blockTypeState === void 0 ? void 0 : blockTypeState.currentBlockType,
    blockTypesDisabled: blockTypeState === null || blockTypeState === void 0 ? void 0 : blockTypeState.blockTypesDisabled,
    availableBlockTypes: blockTypeState === null || blockTypeState === void 0 ? void 0 : blockTypeState.availableBlockTypes,
    availableBlockTypesInDropdown: blockTypeState === null || blockTypeState === void 0 ? void 0 : blockTypeState.availableBlockTypesInDropdown,
    formattingIsPresent: blockTypeState === null || blockTypeState === void 0 ? void 0 : blockTypeState.formattingIsPresent
  };
});
export function PrimaryToolbarComponent(_ref) {
  var api = _ref.api,
    isSmall = _ref.isSmall,
    disabled = _ref.disabled,
    isToolbarReducedSpacing = _ref.isToolbarReducedSpacing,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement,
    shouldUseDefaultRole = _ref.shouldUseDefaultRole;
  var _usePrimaryToolbarCom = usePrimaryToolbarComponentPluginState(api),
    currentBlockType = _usePrimaryToolbarCom.currentBlockType,
    blockTypesDisabled = _usePrimaryToolbarCom.blockTypesDisabled,
    availableBlockTypes = _usePrimaryToolbarCom.availableBlockTypes,
    availableBlockTypesInDropdown = _usePrimaryToolbarCom.availableBlockTypesInDropdown,
    formattingIsPresent = _usePrimaryToolbarCom.formattingIsPresent;
  var boundSetBlockType = function boundSetBlockType(name, fromBlockQuote) {
    var _api$core, _api$blockType;
    return api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.setTextLevel(name, INPUT_METHOD.TOOLBAR, fromBlockQuote));
  };
  var wrapBlockQuote = function wrapBlockQuote() {
    var _api$core2, _api$blockType2;
    return api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 ? void 0 : _api$core2.actions.execute(api === null || api === void 0 || (_api$blockType2 = api.blockType) === null || _api$blockType2 === void 0 || (_api$blockType2 = _api$blockType2.commands) === null || _api$blockType2 === void 0 ? void 0 : _api$blockType2.insertBlockQuote(INPUT_METHOD.TOOLBAR));
  };
  var clearFormatting = function clearFormatting() {
    var _api$core3, _api$blockType3;
    return api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 ? void 0 : _api$core3.actions.execute(api === null || api === void 0 || (_api$blockType3 = api.blockType) === null || _api$blockType3 === void 0 || (_api$blockType3 = _api$blockType3.commands) === null || _api$blockType3 === void 0 ? void 0 : _api$blockType3.clearFormatting(INPUT_METHOD.TOOLBAR));
  };
  return /*#__PURE__*/React.createElement(ToolbarBlockType, {
    isSmall: isSmall,
    isDisabled: disabled,
    isReducedSpacing: isToolbarReducedSpacing,
    setTextLevel: boundSetBlockType,
    wrapBlockQuote: wrapBlockQuote,
    clearFormatting: clearFormatting,
    currentBlockType: currentBlockType,
    blockTypesDisabled: blockTypesDisabled,
    availableBlockTypes: availableBlockTypes,
    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
    formattingIsPresent: formattingIsPresent,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement,
    shouldUseDefaultRole: shouldUseDefaultRole,
    api: api
  });
}